import React, { FC, useMemo } from 'react';
import { useTranslate } from '@translations/useTranslate';
import { CustomRoundButton } from '@ui/components/atoms';
import { Translations } from '@translations/translationsTypes';
import { useHistory } from 'react-router-dom';
import styles from './documentsGrid.module.scss';
import { DocumentCard, FeatureCard } from './Components';
import { useGetStaticDocuments } from './hooks';

const DocumentCards: FC = () => {
  const { t, language } = useTranslate();
  const history = useHistory();

  const { staticFilesEn, staticFilesAr, knowLedgeCenterPoints } = useGetStaticDocuments();

  const documents = useMemo(() => {
    if (language === Translations.ar) {
      return staticFilesAr;
    }
    return staticFilesEn;
  }, [language, staticFilesAr, staticFilesEn]);

  return (
    <>
      <div className={styles.titleSection}>
        <h2 className="w-100 text-center fw-bold pt-2 pb-3">{t('knowledgecenter.page.header')}</h2>
        <p>{t('knowledgecenter.page.description')}</p>
        <p>
          <b>{t('knowledgecenter.page.staic.card.header')}</b>
        </p>
        <div className={styles.grid}>
          {knowLedgeCenterPoints.map((item) => (
            <FeatureCard
              description={item.description}
              title={item.title}
              key={item.title}
              imageUrl={item.imageUrl}
              alternateName={item.alternateName}
            />
          ))}
        </div>
        <div className={styles.buttonClass}>
          <CustomRoundButton
            onClick={() => {
              history.push(`/foi-request/${language}`);
            }}
            variant="primary"
            text={t('knowledgecenter.page.rrquest.button')}
          />
        </div>
      </div>

      <div className={styles.grid}>
        {documents.map((doc, i) => (
          <DocumentCard key={i} {...doc} />
        ))}
      </div>
      <div className="w-100 pb-5 mt-5 d-flex justify-content-center">
        <p className="text-dark fw-bold">{t('knowledgecenter.note')}</p>
      </div>
    </>
  );
};

export { DocumentCards };
